import styled from 'styled-components';
import GenericDropDown from '../../../../shared/common/GenericDropDown';
import { textColor, THEME_PRIMARY, THEME_SILVER, themeColor } from '../../../../styles/basics/colors';
import { GrowingInput } from '../../../../shared/common/GrowingInput';
import { ButtonTextWidthAuto } from '../../../../shared/common/Button/ButtonTextWidthAuto';

export const StContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 62px;
`;

export const StBackButton = styled.a`
    margin-right: 10px;
    font-size: 28px;
    line-height: 1;
`;

export const StMoreButton = styled(GenericDropDown)`
    font-size: 22px;
    line-height: 1;

    && a {
        padding: 0;
        font-size: inherit;
        line-height: inherit;
    }
`;
export const StHeadlinePart = styled.div`
    display: flex;
    align-items: center;
`;

export const StTitle = styled.div`
    position: relative;
    margin-right: 13px;
    font-size: 20px;
    line-height: 1;
`;

interface TitleFormProps {
    active: boolean;
}

export const StTitleForm = styled.div<TitleFormProps>`
    padding-right: ${props => (props.active ? '30px' : null)};
    border-bottom: 1px solid ${props => (props.active ? themeColor(THEME_SILVER) : 'transparent')};
`;
// This is a workaround for the fact that when the input text is too long, it will break the layout
// https://borrowbox.atlassian.net/browse/PORTAL-4573
export const StNameInput = styled(GrowingInput)`
    border-radius: 0;
    box-shadow: none;
    font-size: 20px;
    min-width: 50px;
    padding: 0;
    max-width: 260px;
    overflow: ${props => (props.truncated ? 'hidden' : null)};
    text-overflow: ${props => (props.truncated ? 'ellipsis' : null)};
    white-space: nowrap;
    overflow: hidden;

    ::-ms-clear {
        display: none;
    }
`;

interface StCheckProps {
    active: boolean;
}

export const StCheck = styled.i<StCheckProps>`
    display: ${props => (props.active ? null : 'none')};
    ${textColor(THEME_PRIMARY)};
    cursor: pointer;
    position: absolute;
    right: 0;
    font-size: inherit;
`;

export const StButtonTextWidthAuto = styled(ButtonTextWidthAuto)`
    margin-left: 10px;
`;
